import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Form, FloatingLabel } from "react-bootstrap";
import { TalukServices } from "../../../services/Taluk";
import { PHCServices } from "../../../services/Phcs";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../components/LoadingModal.js";
import AlertModal from "../../../components/AlertModal.js";
import styles from "../../../styles/Modal.module.css";

function AddPHC(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Taluk State
  const [taluks, setTaluks] = useState([]);
  useEffect(() => {
    const getTaluks = async () => {
      try {
        const res = await TalukServices.getAllTaluks();
        setTaluks(Array.isArray(res) ? res : []);
      } catch (error) {
        console.error("Error fetching taluks:", error);
        setTaluks([]);
      }
    };
    getTaluks();
  }, []);

  // PHC Form State
  const initialPhcState = { phc: "", talukId: "" };
  const [phc, setPhc] = useState(initialPhcState);
  const [error, setError] = useState({ phc: "", talukId: "" });

  // Alert Modal State
  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const validation = () => {
    let tempError = { phc: "", talukId: "" };
    let valid = true;
    if (!phc.phc.trim()) {
      tempError.phc = "PHC is required";
      valid = false;
    }
    if (!phc.talukId) {
      tempError.talukId = "Taluk is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const savePhc = async () => {
    if (!validation()) return;

    setLoading(true);
    try {
      const res = await PHCServices.addPhc(phc);
      if (res.status === 200) {
        setAlertData({
          show: true,
          title: "Success",
          message: res.message || "PHC added successfully!",
          variant: "success",
        });
        setPhc(initialPhcState);
        props.onClose && props.onClose();
      } else {
        throw new Error(res.message || "Error while adding PHC");
      }
    } catch (error) {
      setAlertData({
        show: true,
        title: "Error",
        message: error.message || "Failed to add PHC. Please try again.",
        variant: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAlertClose = () => {
    setAlertData((prev) => ({ ...prev, show: false }));
    if (alertData.variant === "success") {
      props.onHide();
      navigate("/phc");
    }
  };

  return (
    <>
      <Modal {...props} size="md" centered className={styles.modalShow}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            <i className="fas fa-plus-circle me-2"></i>
            Add New PHC
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="Taluk"
              label={
                <>
                  Taluk <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Select
                value={phc.talukId}
                onChange={(e) => setPhc({ ...phc, talukId: e.target.value })}
                isInvalid={!!error.talukId}
                className="mb-3"
              >
                <option value="">Select Taluk</option>
                {taluks.map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.taluk}
                  </option>
                ))}
              </Form.Select>
              {error.talukId && (
                <div className="invalid-feedback d-block">
                  {error.talukId}
                </div>
              )}
            </FloatingLabel>
          </div>

          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="phc"
              label={
                <>
                  PHC Name <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Control
                type="text"
                placeholder="Enter PHC name"
                value={phc.phc}
                onChange={(e) => setPhc({ ...phc, phc: e.target.value })}
                isInvalid={!!error.phc}
              />
              <Form.Control.Feedback type="invalid">
                {error.phc}
              </Form.Control.Feedback>
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button
            variant="success"
            onClick={savePhc}
            className={styles.primaryButton}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save me-1"></i>
                Save PHC
              </>
            )}
          </Button>
          <Button
            variant="danger"
            onClick={props.onHide}
            className={styles.secondaryButton}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      {/* Alert Modal only */}
      <AlertModal
        show={alertData.show}
        onHide={handleAlertClose}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
      />
    </>
  );
}

export default AddPHC;
